/*@ngInject*/
const UiPerformanceLogger = function (coreMediator, clientType) {

    let activeLogs = {};

    this.startLog = function (logAction, message) {
        // Create an activeLog entry and store it in the map.
        let activeLog = {
            logAction: logAction,
            message: message,
            startTime: new Date()
        };

        activeLogs[logAction] = activeLog;
    };

        this.endLog = function (logAction, status, newMessage, isLogOut) {
            if (activeLogs[logAction]) {
                let activeLog = activeLogs[logAction];
                if(isLogOut) {
                    endLogContinue(logAction, status, newMessage);
                } else {
                    coreMediator.loadUserProfile().then(function (userProfile) {
                        activeLog.username = userProfile.userName;
                        endLogContinue(logAction, status, newMessage);
                    });
                }
            }
        };

    this.endLogWithoutLogging = function (logAction) {
        if (activeLogs[logAction]) {
            delete activeLogs[logAction];
        }
    };

    function endLogContinue(logAction, status, newMessage) {
        // Retrieve the activeLog entry and persist the record to the server.
        let activeLog = activeLogs[logAction];
        let now = new Date();
        let uiPerformanceLog = {
            logAction: logAction,
            message: newMessage ? newMessage : activeLog.message,
            username: activeLog.username,
            elapsedTime: (now - activeLog.startTime) / 1000,
            status: status,
            clientType: clientType.HTML,
            logDate: now.getTime()
        };

        // Make sure to clear the log from the activeLogs map, and make sure to do it before making
        // the async request to ensure that another broadcast of the END_UI_PERFORMANCE_LOG can trigger
        // sending the same log.
        delete activeLogs[logAction];

        coreMediator.createUiPerformanceLog(uiPerformanceLog);
    }
};

angular.module('umCore')
    .service('uiPerformanceLogger', UiPerformanceLogger);
